import React, { useState } from "react";
import {
  ContactBar,
  ContactBarChild,
  HeaderContainer,
  HeaderLogoContainer,
  HeaderLogo,
  NavbarChild,
  Navbar,
  Container,
  HamburgerIcon,
} from "../../styled-components/header";
import Logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";

function Header(props) {
  const navigate = useNavigate();
  const setLocation = (link, external) => {
    if (external) {
      document.location = link;
    } else {
      navigate(link);
    }
  };
  const [showNav, setShowNav] = useState(false);
  const toggleNav = () => {
    setShowNav(!showNav);
  };

  return (
    <>
      <ContactBar>
        <ContactBarChild>
          <ion-icon name="call-outline"></ion-icon> &nbsp;
        </ContactBarChild>
        <ContactBarChild>
          <ion-icon name="mail-outline"></ion-icon>{" "}
          &nbsp;info@tangentmotorsport.com
        </ContactBarChild>
      </ContactBar>
      <HamburgerIcon onClick={toggleNav}>
        <ion-icon name="menu-outline"></ion-icon>
      </HamburgerIcon>
      <Container>
        <HeaderContainer>
          <HeaderLogoContainer>
            <HeaderLogo src={Logo} />
          </HeaderLogoContainer>
          <Navbar showNav={showNav}>
            <NavbarChild
              onClick={() => {
                setLocation("https://tangentmotorsport.com", true);
              }}
            >
              Home
            </NavbarChild>
            <NavbarChild
              onClick={() => {
                setLocation("/", false);
              }}
            >
              All Apps
            </NavbarChild>
            <NavbarChild
              onClick={() => {
                setLocation("/edc15", false);
              }}
            >
              EDC15
            </NavbarChild>
            <NavbarChild
              onClick={() => {
                setLocation("/med9", false);
              }}
            >
              MED9
            </NavbarChild>
            <NavbarChild
              onClick={() => {
                setLocation("https://tangentmotorsport.com/?page_id=8", true);
              }}
            >
              Contact Us
            </NavbarChild>
          </Navbar>
        </HeaderContainer>
      </Container>
    </>
  );
}

export default Header;
